module.exports = __webpack_public_path__ + "static/media/gameDeskCleanup.20361332.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameDeskCleanup.png
// module id = 2347
// module chunks = 0